<ng-container *ngIf="willRender">
  <ng-container [formGroup]="parentFormGroup" *ngIf="!inputModel?.calendar">
    <pg-field [size]="inputModel?.size">
      <label pgLabel>{{ inputModel?.label }}</label>
      <input
        pgInput
        #input="pgInput"
        [placeholder]="inputModel?.placeholder"
        [disabled]="inputModel?.disabled"
        [textMask]="getMask()"
        [formControlName]="inputModel?.formControlName"
        [maxlength]="getMaxLength()"
        [type]="getInputType()"
        (input)="handleFieldInput($event)"
        [id]="inputModel?.id"
        (focus)="handleBehaviorEvent('onFocus', $event)"
        (blur)="handleBehaviorEvent('onBlur', $event)"
        (input)="handleBehaviorEvent('onInput', $event)"
        [secure]="inputModel?.secure"
      />

      <pg-subscript-messages>
        <span *ngIf="inputModel?.hint" pgHint>{{ inputModel.hint }}</span>
        <span *ngIf="inputModel.required" pgError [for]="'required'">
          {{ inputModel.requiredMessage }}</span
        >
        <span
          *ngFor="let validation of inputModel?.validationList"
          pgError
          id="validation.id"
          [for]="validation.errorKey"
          >{{ validation.message }}</span
        >
      </pg-subscript-messages>
      <pg-suffix-icons>
        <pg-icon
          *ngFor="let icon of inputModel?.suffixIcons"
          pgSuffixIcon
          [visible]="isIconVisible(icon)"
          [style.cursor]="
            icon.onClick && icon.onClick.length ? 'pointer' : null
          "
          (click)="handleSuffixIconClicked($event, icon)"
          >{{ icon.iconName }}</pg-icon
        >
        <pg-icon class="fg-red400" pgSuffixIcon [visible]="input.isError"
          >warning</pg-icon
        >
        <pg-icon
          class="fg-green500"
          pgSuffixIcon
          [visible]="
            !inputModel.validationIconDisabled &&
            !input.isError &&
            !input.isEmpty &&
            !input.isFocused &&
            !input.isDisabled &&
            !inputModel.loading
          "
          >done</pg-icon
        >

        <ng-container *ngIf="inputModel?.visibilityCanToggle">
          <pg-icon
            class="visibility-icon visible"
            pgSuffixIcon
            (click)="visibilityController.handleShowFieldIconClicked()"
            [visible]="!visibilityController?.isFieldVisible"
            >visibility</pg-icon
          >
          <pg-icon
            class="visibility-icon visible-off"
            pgSuffixIcon
            (click)="visibilityController.handleHideFieldIconClicked()"
            [visible]="visibilityController?.isFieldVisible"
            >visibility_off</pg-icon
          >
        </ng-container>
        <pg-spinner pgSuffixIcon [visible]="inputModel?.loading"></pg-spinner>
      </pg-suffix-icons>
      <pg-prefix-icons
        *ngIf="inputModel?.prefixIcon"
        iconDisplayOption="inputModel?.prefixIcon.iconDisplayOption"
      >
        <pg-icon pgPrefixIcon>{{ inputModel.prefixIcon.iconName }}</pg-icon>
      </pg-prefix-icons>

      <pg-field-bottom-border-gap
        *ngIf="inputModel?.selectItems && inputModel?.selectItems.length"
      >
        <pg-drop-down>
          <span
            pgDropDownItem
            *ngFor="let item of inputModel.selectItems"
            [searchableTerms]="item.searchTerms"
            [value]="item.value"
            >{{ item.display }}</span
          >
        </pg-drop-down>
      </pg-field-bottom-border-gap>
    </pg-field>
  </ng-container>

  <ng-container [formGroup]="parentFormGroup" *ngIf="inputModel?.calendar">
    <pg-field [size]="inputModel?.size">
      <label pgLabel>{{ inputModel?.label }}</label>

      <input
        pgInput
        #input="pgInput"
        [placeholder]="inputModel?.placeholder"
        [disabled]="inputModel?.disabled"
        [textMask]="getMask()"
        [formControlName]="inputModel?.formControlName"
        [maxlength]="getMaxLength()"
        [type]="getInputType()"
        (input)="handleFieldInput($event)"
        [id]="inputModel?.id"
        (focus)="handleBehaviorEvent('onFocus', $event)"
        (blur)="handleBehaviorEvent('onBlur', $event)"
        (input)="handleBehaviorEvent('onInput', $event)"
        [secure]="inputModel?.secure"
        [pgCalendarInput]="calendar"
      />

      <pg-subscript-messages>
        <span *ngIf="inputModel?.hint" pgHint>{{ inputModel.hint }}</span>
        <span *ngIf="inputModel.required" pgError [for]="'required'">
          {{ inputModel.requiredMessage }}</span
        >
        <span
          *ngFor="let validation of inputModel?.validationList"
          pgError
          [for]="validation.errorKey"
          >{{ validation.message }}</span
        >
      </pg-subscript-messages>
      <pg-suffix-icons>
        <pg-icon
          *ngFor="let icon of inputModel?.suffixIcons"
          pgSuffixIcon
          [visible]="isIconVisible(icon)"
          [style.cursor]="
            icon.onClick && icon.onClick.length ? 'pointer' : null
          "
          (click)="handleSuffixIconClicked($event, icon)"
          >{{ icon.iconName }}</pg-icon
        >
        <pg-icon class="fg-red400" pgSuffixIcon [visible]="input.isError"
          >warning</pg-icon
        >
        <pg-icon
          class="fg-green500"
          pgSuffixIcon
          [visible]="
            !inputModel.validationIconDisabled &&
            !input.isError &&
            !input.isEmpty &&
            !input.isFocused &&
            !input.isDisabled &&
            !inputModel.loading
          "
          >done</pg-icon
        >

        <ng-container *ngIf="inputModel?.visibilityCanToggle">
          <pg-icon
            class="visibility-icon visible"
            pgSuffixIcon
            (click)="visibilityController.handleShowFieldIconClicked()"
            [visible]="!visibilityController?.isFieldVisible"
            >visibility</pg-icon
          >
          <pg-icon
            class="visibility-icon visible-off"
            pgSuffixIcon
            (click)="visibilityController.handleHideFieldIconClicked()"
            [visible]="visibilityController?.isFieldVisible"
            >visibility_off</pg-icon
          >
        </ng-container>
        <pg-spinner pgSuffixIcon [visible]="inputModel?.loading"></pg-spinner>
      </pg-suffix-icons>
      <pg-prefix-icons
        *ngIf="inputModel?.prefixIcon"
        iconDisplayOption="inputModel?.prefixIcon.iconDisplayOption"
      >
        <pg-icon pgPrefixIcon>{{ inputModel.prefixIcon.iconName }}</pg-icon>
      </pg-prefix-icons>

      <pg-field-bottom-border-gap
        *ngIf="inputModel?.selectItems && inputModel?.selectItems.length"
      >
        <pg-drop-down>
          <span
            pgDropDownItem
            *ngFor="let item of inputModel.selectItems"
            [searchableTerms]="item.searchTerms"
            [value]="item.value"
            >{{ item.display }}</span
          >
        </pg-drop-down>
      </pg-field-bottom-border-gap>
    </pg-field>
    <pg-calendar
      #calendar
      [minDate]="inputModel.calendar.minDate"
      [maxDate]="inputModel.calendar.maxDate"
      [format]="inputModel.calendar.format"
    >
      <span pgLabel [innerHTML]="inputModel.calendar.title"></span>
    </pg-calendar>
  </ng-container>
</ng-container>
